(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.controller('WizardControllerV2', ["$scope", "wizardHelper", "sizeClasses", "$routeParams", "$route", "modulesDao", "wizardDao", "$q", "modulesManager", "routeHelper", "path", "sideMenuManager", "commonDao", "feature", "appConfigurator", "dualAppHelper", "$timeout", "loadingModal", "$cookies", "autologinHelper", "iframeMessagingService", "$rootScope", function ($scope, wizardHelper, sizeClasses, $routeParams, $route, modulesDao, wizardDao, $q, modulesManager, routeHelper, path, sideMenuManager, commonDao, feature, appConfigurator, dualAppHelper, $timeout, loadingModal, $cookies, autologinHelper, iframeMessagingService, $rootScope) {
        $scope.loading = true;
        $scope.getSizeClasses = sizeClasses;
        $scope.wizardHelper = wizardHelper;
        $scope.userManagementUrl = routeHelper.getHref('wizard-user-management');
        $scope.imgRoot = path('gui-v2').ctrl('wizard-v2');
        $scope.stepInfo = {};
        $scope.terms = { accepted: false };
        $scope.appSpacers = _.range(1, 10);
        $scope.processingDualAppWizard = false;
        $scope.loadingDualAuth = false;
        $scope.autologinCP = autologinHelper.enabled() || $cookies.get('autologinCP');
        $scope.feature = feature;
        // group filter popup check
        var selectGroupsStage = window.localStorage.getItem('selectGroupsStage');
        if (selectGroupsStage) {
            modulesDao.displayUserGroupsFilterModal(selectGroupsStage);
        }
        if (feature.checkpointTheme) {
            $scope.topLogo = path('gui-v2').directive('side-menu-v2').imgRel('check-point-black.png');
        } else if (feature.lastlineTheme) {
            $scope.topLogo = path('gui-v2').directive('side-menu-v2').imgRel('lastline-logo-1.png');
        } else if (feature.sonicwallTheme) {
            $scope.topLogo = path('gui-v2').directive('side-menu-v2').imgRel('sonicwall-logo-1.png');
        } else {
            $scope.topLogo = path('gui-v2').directive('side-menu-v2').imgRel('avanan-logo-dark-teal-HiRes.png');
        }
        wizardHelper.reset();
        wizardHelper.scope($scope);
        var enabledMap = {};
        $scope.allowNav = function () {
            return modulesManager.activeSaasApps().length > 0 && !appConfigurator.watchdogCheckInProgress;
        };
        $scope.exit = function () {
            if (!$scope.allowNav()) {
                return;
            }
            wizardHelper.setStatus('disabled').then(function () {
                routeHelper.redirectTo('dashboard');
            });
        };
        $scope.goNext = function () {
            if ($scope.loading || !$scope.allowNav() && $scope.currentStep > 0) {
                return;
            }
            if ($scope.stepInfo.type === 'category-selector') {
                $scope.startingApps = true;
                return wizardDao.startApps($scope.stepInfo.autoStart || $scope.startCategories).then(function () {
                    $scope.startingApps = false;
                    goToStep($scope.currentStep + 1);
                }).catch(function () {
                    console.log('Error on starting apps.');
                    $scope.startingApps = false;
                    goToStep($scope.currentStep + 1);
                });
            }
            if ($scope.stepInfo.startApps) {
                $scope.loading = true;
                $scope.startingApps = true;
                return wizardDao.startApps($scope.stepInfo.startApps).then(function () {
                    $scope.startingApps = false;
                    goToStep($scope.currentStep + 1);
                }).catch(function () {
                    console.log('Error on starting apps.');
                    $scope.startingApps = false;
                    goToStep($scope.currentStep + 1);
                });
            }
            goToStep($scope.currentStep + 1);
        };
        $scope.goBack = function () {
            if ($scope.loading) {
                return;
            }
            goToStep($scope.currentStep - 1);
        };
        $scope.stepDone = function (step) {
            return enabledMap[step];
        };
        $scope.progressStepByIndex = function (idx) {
            return wizardHelper.steps.length - idx - 1;
        };
        $scope.hereStyle = function () {
            if ($scope.currentStep !== wizardHelper.steps.length - 2) {
                return { left: ($scope.currentStep - 1) * (33 + 36) + 10 + 'px' };
            } else {
                return {
                    left: 'auto',
                    right: '-15px'
                };
            }
        };
        $scope.acceptTerms = function () {
            return commonDao.acceptTerms().then(function (response) {
                $scope.terms.accepted = response.data;
            });
        };
        function getCategories(categories, params) {
            return _(categories).filter(function (category) {
                return _(params).reduce(function (memo, value, key) {
                    return memo && category[key] === value;
                }, true);
            });
        }
        function setEnabledMap(categories) {
            enabledMap = _(wizardHelper.steps).map(function (info) {
                if (info.type === 'info') {
                    return true;
                }
                if (info.type === 'category-selector') {
                    return false;
                }
                return !_(getCategories(categories, info.categoryFilter)).chain().find(function (category) {
                    return category.haveActiveItems;
                }).isUndefined().value();
            });
        }
        function checkingDualAppStatus() {
            try {
                var dualAuthStarted = JSON.parse(window.localStorage.getItem('dualAuthStarted'));
                if (dualAuthStarted && dualAuthStarted.saas) {
                    var checkSaaS = dualAppHelper.checkDualApp(dualAuthStarted.saas);
                    if (checkSaaS.isDualApp) {
                        return dualAppHelper.authenticationStatus(checkSaaS.authName, dualAuthStarted.saas, dualAuthStarted.mode).then(function (response) {
                            if (response.data.hasOwnProperty('step') && response.data.step === 1) {
                                return {
                                    currentStep: response.data.step,
                                    currentSaaS: dualAuthStarted.saas,
                                    dualAppStatus: 'inProgress'
                                };
                            } else if (response.data.hasOwnProperty('done')) {
                                return {
                                    authName: checkSaaS.authName,
                                    currentSaaS: dualAuthStarted.saas,
                                    dualAppStatus: 'done'
                                };
                            } else {
                                return null;
                            }
                        });
                    } else if (dualAuthStarted.saas === 'office365_emails') {
                        $rootScope.saasAuthStarted = 'office365_emails';
                    }
                }
            } catch (e) {
                console.log('--error on app-store-v2 checkingDualAppStatus---', e);
            }
            return null;
        }
        var prevResponse = null;
        function responseModules(response) {
            return _(response.data.widgets).map(function (widget) {
                return _(widget.options).omit('configurationLink');    //Is it safe?
            });
        }
        function loadModules(response) {
            if (!_(prevResponse).isEqual(responseModules(response))) {
                prevResponse = responseModules(response);
                setEnabledMap(response.data.categories);
                wizardHelper.setWidgets(response.data.widgets);
            }
            if ($scope.stepInfo.modulesRecheck) {
                modulesManager.reloadModules();
            }
            $scope.loading = false;
        }
        function reloadFn(params, currentStatus) {
            return wizardDao.getApps($scope.stepInfo).params(params).then(function (response) {
                if (currentStatus && !$scope.processingDualAppWizard) {
                    var currentIndex = _(response.data.widgets).findIndex(function (widget) {
                        return currentStatus.currentSaaS === widget.options.moduleName && widget.options.moduleStatus === 'nonactive';
                    });
                    if (currentIndex !== -1) {
                        var currentApp = response.data.widgets[currentIndex].options;
                        if (currentStatus.currentStep) {
                            $scope.processingDualAppWizard = true;
                            currentApp.currentStep = currentStatus.currentStep;
                            dualAppHelper.dualAppWizard(currentApp);
                            loadModules(response);
                        } else if (currentStatus.dualAppStatus === 'done') {
                            $scope.processingDualAppWizard = true;
                            try {
                                window.localStorage.removeItem('dualAuthStarted');
                            } catch (e) {
                                console.log('--error during removing dualAuthstarted localstorage---', e);
                            }
                            loadModules(response);
                            if (!$scope.loading) {
                                wizardHelper.activateDualApp(currentApp.moduleName);
                            }
                        }
                    } else {
                        loadModules(response);
                    }
                } else {
                    loadModules(response);
                }
            });
        }
        $scope.goToDashobard = function () {
            iframeMessagingService.sendMessage({ type: 'go-to-dashboard' });
        };
        function goToStep(step, currentStatus) {
            $scope.loading = true;
            $scope.currentStep = parseInt(step);
            if (!isFinite($scope.currentStep) || !$scope.allowNav() && $scope.currentStep > 1) {
                $scope.currentStep = 0;
            }
            $scope.stepInfo = wizardHelper.steps[$scope.currentStep];
            if ($scope.stepInfo.titleNavAllowed) {
                $scope.title = $scope.allowNav() ? $scope.stepInfo.titleNavAllowed : $scope.stepInfo.title;
            } else {
                $scope.title = $scope.stepInfo.title;
            }
            if ($scope.stepInfo.titleAddUser) {
                $scope.title += ', ' + sideMenuManager.currentUser().email;
            }
            if ($scope.stepInfo.linkGoTo) {
                $scope.linkUrl = routeHelper.getHref($scope.stepInfo.linkGoTo, $scope.stepInfo.linkGoToParams);
            } else {
                $scope.linkUrl = null;
            }
            $scope.stepInfo.showTerms = false;
            wizardHelper.setStep($scope.currentStep);
            if (!$scope.stepInfo) {
                wizardHelper.reset();
                routeHelper.redirectTo('dashboard');
                return;
            }
            if ($scope.stepInfo.type === 'info') {
                wizardHelper.reset();
                $scope.loading = false;
                if ($scope.stepInfo.disableWizard) {
                    wizardHelper.setStatus('disabled');
                }
                if ($scope.stepInfo.isLast) {
                    var activeApps = modulesManager.activeSaasApps();
                    if (activeApps.length) {
                        var htmlForActiveApps = '';
                        var foundSaas = 0;
                        _(activeApps).each(function (app, key) {
                            if (app.name.indexOf('office365') !== -1 || app.name.indexOf('google') !== -1) {
                                foundSaas++;
                            }
                            if ([
                                    'box',
                                    'dropbox'
                                ].includes(app.name)) {
                                modulesDao.operation(app.name, 'start');
                            }
                            htmlForActiveApps += '<strong>' + (key + 1) + '. ' + app.title + '</strong><br/>';
                        });
                        $scope.stepInfo.alert = 'Dear user,<br/>' + 'You\'ve started the following apps:<br/><br/>' + htmlForActiveApps;
                        if (foundSaas && feature.sonicwallTheme) {
                            $scope.stepInfo.alert += '<strong>The initial setup process can take some time to complete.<br/>' + 'During this time, you will not see data populated in the dashboards. You will receive an onboarding' + ' finished successfully email when your Office 365 / G Suite integration is ready for use.</strong><br/>';
                        }
                    }
                }
                return;
            }
            if ($scope.stepInfo.type === 'category-selector') {
                wizardHelper.reset();
                if ($scope.stepInfo.autoStart) {
                    $scope.loading = false;
                    $scope.goNext();
                    return;
                }
                $scope.loading = true;
                $scope.visibleCategories = {};
                $scope.startCategories = _($scope.stepInfo.categories).chain().map(function (category) {
                    return [
                        category.type,
                        false
                    ];
                }).object().value();
                wizardDao.wizardApps().then(function (categoriesConfig) {
                    $scope.visibleCategories = _($scope.stepInfo.categories).chain().map(function (category) {
                        var categoryVisible = categoriesConfig && categoriesConfig[category.type] || false;
                        if (categoryVisible && category.selected) {
                            $scope.startCategories[category.type] = true;
                        }
                        return [
                            category.type,
                            categoryVisible
                        ];
                    }).object().value();
                    $scope.loading = false;
                });
                return;
            }
            $scope.startingApps = false;
            if ($scope.stepInfo.terms) {
                commonDao.getTermsAccepted().then(function (response) {
                    $scope.terms.accepted = response.data;    //$scope.stepInfo.showTerms = !$scope.terms.accepted; // don't show 'accept terms now since it's shown in the dialog
                });
            }
            prevResponse = null;
            wizardHelper.reload(function (params) {
                return wizardDao.getApps($scope.stepInfo).params(params).then(function (response) {
                    if (currentStatus && !$scope.processingDualAppWizard) {
                        var currentIndex = _(response.data.widgets).findIndex(function (widget) {
                            return currentStatus.currentSaaS === widget.options.moduleName && widget.options.moduleStatus === 'nonactive';
                        });
                        if (currentIndex !== -1) {
                            var currentApp = response.data.widgets[currentIndex].options;
                            if (currentStatus.currentStep) {
                                $scope.processingDualAppWizard = true;
                                currentApp.currentStep = currentStatus.currentStep;
                                dualAppHelper.dualAppWizard(currentApp);
                                loadModules(response);
                            } else if (currentStatus.dualAppStatus === 'done') {
                                $scope.processingDualAppWizard = true;
                                try {
                                    window.localStorage.removeItem('dualAuthStarted');
                                } catch (e) {
                                    console.log('--error during removing dualAuthStarted localstorage---', e);
                                }
                                loadModules(response);
                                if (!$scope.loading) {
                                    wizardHelper.activateDualApp(currentApp.moduleName);
                                }
                            }
                        } else {
                            loadModules(response);
                        }
                    } else {
                        loadModules(response);
                    }
                });
            }, $scope.stepInfo.updateTick);
        }
        wizardHelper.reloadState().then(function () {
            var p = $q.when();
            return p.then(function () {
                return checkingDualAppStatus();
            }).then(function (data) {
                var state = wizardHelper.getState();
                if (state.inProgress) {
                    goToStep(state.savedStep, data);
                    return;
                }
                modulesManager.reloadModules().then(function () {
                    if (modulesManager.activeSaasApps().length) {
                        routeHelper.redirectTo('dashboard', { module: modulesManager.currentModule() });
                        return;
                    }
                    $q.all([
                        wizardHelper.setStatus('enabled'),
                        wizardHelper.setStep(null)
                    ]);
                    state.savedStep = null;
                    goToStep(state.savedStep, data);
                });
            });
        });
        $scope.getWidgetClasses = function (widget) {
            var result = {};
            result[$scope.getSizeClasses(widget.size)] = true;
            result['module-' + widget.options.moduleName] = true;
            return result;
        };
        $scope.toggleCategoryState = function (type) {
            $scope.startCategories[type] = !$scope.startCategories[type];
        };
        $scope.categoryTooltip = function (category) {
            var text;
            if ($scope.startCategories[category.type]) {
                text = 'Click to de-select ' + category.label;
            } else {
                text = 'Click to select ' + category.label;
            }
            return {
                content: { text: text },
                position: {
                    at: 'top center',
                    my: 'bottom left',
                    viewport: true
                }
            };
        };
        $scope.$on('$destroy', function () {
            wizardHelper.reset();
        });
        function dualAuthTriggerForCloudInfra(currentStep) {
            $scope.processingDualAppWizard = false;
            var p = $q.when();
            return p.then(function () {
                return checkingDualAppStatus();
            }).then(function (status) {
                if (status && (currentStep === 0 && status.currentStep === 1 || currentStep === 0 && status.dualAppStatus === 'done' && status.authName === 'gsuite' || currentStep === 1 && status.dualAppStatus === 'done')) {
                    loadingModal.dismiss();
                    reloadFn(null, status);
                } else {
                    $timeout(function () {
                        dualAuthTriggerForCloudInfra(currentStep);
                    }, 1000);
                }
            });
        }
        $scope.$on('dual-auth-started-1', function () {
            loadingModal.show({
                title: 'Waiting for app authorization',
                comment: 'Click anywhere to stop waiting'
            });
            dualAuthTriggerForCloudInfra(0);
        });
        $scope.$on('dual-auth-started-2', function () {
            loadingModal.show({
                title: 'Waiting for app authorization',
                comment: 'Click anywhere to stop waiting'
            });
            dualAuthTriggerForCloudInfra(1);
        });
        function appsReload(saas) {
            modulesDao.getAppInfo(saas).then(function (res) {
                if (res && res.data && res.data.options && res.data.options.operation === 'start') {
                    if (res.data.saasAuthorized) {
                        wizardHelper.activateApp(res.data.moduleName, false, res.data);
                    } else {
                        $timeout(function () {
                            appsReload(saas);
                        }, 1000);
                    }
                }
            });
        }
        $scope.$on('close-app-configurator', function (event, args) {
            if (args && args.saas === 'office365_emails' && $rootScope.saasAuthStarted && $rootScope.saasAuthStarted === args.saas) {
                appsReload(args.saas);
            }
        });
    }]);
}());